import { Form, TimePicker } from 'antd';
import React from 'react';
import { TIME_12_HOUR_FORMAT } from 'utilities/dates/date';
import { FormItemProps } from 'antd/es/form';

interface Props extends FormItemProps<string> {
  placeholder?: string;
}

const timePickerStyles = { width: '100%' };
export function FieldTime(props: Props) {
  const { name, label, placeholder, required = true } = props;
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required, message: 'Please select one option' }]}
    >
      <TimePicker
        use12Hours
        style={timePickerStyles}
        format={TIME_12_HOUR_FORMAT}
        showNow={false}
        minuteStep={1}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}
